export default class SearchSuggestionForm {
    constructor($form) {
        let term = (new URL(window.location.href)).searchParams.get('q');
        if ($form.length > 0) {
            $form.style.display = 'block';

            if ( ! term) {
                return;
            }

            var text = '';
            text += 'Ik zocht een recept '+ term +', maar heb niets gevonden ';
            text += 'op njam.tv. Ik zou graag de suggestie doen om dat recept toe te ';
            text += 'voegen op njam.tv!';

            document.getElementById('request').value = text;
        }
    }
}